import {getMethod, postMethod, putMethod, deleteMethod} from '~/api'

async function get(packageId, request) {
    return await getMethod(`/api/ownPackageContracts/${packageId}/itinerary`, request)
}

async function post(packageId, request) {
    return await postMethod(`/api/ownPackageContracts/${packageId}/itinerary`, request)
}

async function put(packageId, itineraryId, request) {
    return await putMethod(`/api/ownPackageContracts/${packageId}/itinerary/${itineraryId}`, request)
}

async function remove(packageId, itineraryId) {
    return await deleteMethod(`/api/ownPackageContracts/${packageId}/itinerary/${itineraryId}`)
}

export {get, post, put, remove}
